import { render, staticRenderFns } from "./project_approve_pc.vue?vue&type=template&id=7eda4fb0&scoped=true&"
import script from "./project_approve_pc.vue?vue&type=script&lang=js&"
export * from "./project_approve_pc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eda4fb0",
  null
  
)

export default component.exports